import React, { Component } from 'react';
import { TemplateSFObjectStore } from "../../../../../../store/models/template-object.model";
import { CQAppConstant } from '../../../../../../app-constants';
import { ApplyTriggeringField } from '../../../../../../container/triggeringField/triggeringField';


export interface IReference {
    type:string,
    selectedTemplateName: string,
    objLayoutFieldsArray: any[],
    apiName: string,
    loadTriggeringField:boolean,
    onReferenceChange: Function
}

class ReferenceUIType extends Component<IReference,any> {
    constructor(props: any) {
        super(props);
        const value= this.props.objLayoutFieldsArray.length >0? true:false
        this.state = {
            apiName: this.props.apiName,
            loadTriggeringField: value,
            objLayoutFieldsArray:this.props.objLayoutFieldsArray,
        }
    }
    
    componentDidUpdate(){
        this.updateLookupFilter(this.state.objLayoutFieldsArray)
    }

    onChange = (e: any, index?: number) => {
        const { value, name } = e.currentTarget;

        let selectedLookupFilter: any[] = this.props.objLayoutFieldsArray;
        let apiName = this.props.apiName;
        if (name === 'objLayoutFieldsArray' && index !== undefined) {
            if (selectedLookupFilter) {
                selectedLookupFilter[index] = value;
            } else {
                selectedLookupFilter = [];
                selectedLookupFilter[index] = value;
                this.updateLookupFilter(selectedLookupFilter[index])
            }
        } else {
            apiName = value;
        }

        this.props.onReferenceChange({
            type: 'reference',
            apiName: apiName,
            objLayoutFieldsArray: selectedLookupFilter,
            loadTriggeringField:true
        });
        this.setState({ 
            apiName,
            objLayoutFieldsArray: selectedLookupFilter,
        });
    }

    loadTriggeringFieldHandler = () => {
        let selectedLookupFilter =[...this.props.objLayoutFieldsArray];
        selectedLookupFilter.push('');
        this.setState({ loadTriggeringField: !this.state.loadLayoutFieldArray,objLayoutFieldsArray: selectedLookupFilter});
    }

    deleteLookupFilter = (index: number) => {
        let selectedLookupFilter = [...this.state.objLayoutFieldsArray];
        selectedLookupFilter = selectedLookupFilter.filter((fieldName: string, fieldIndex: number) => fieldIndex !== index);
        this.setState({
            objLayoutFieldsArray: selectedLookupFilter
        });
        this.props.onReferenceChange({
            type: 'reference',
            apiName: this.state.apiName,
            objLayoutFieldsArray: selectedLookupFilter,
            loadTriggeringField:true
        });
    }

    addLayoutField = () => {
        let selectedLookupFilter =[...this.state.objLayoutFieldsArray];
        selectedLookupFilter.push('');
        this.setState({ objLayoutFieldsArray: selectedLookupFilter })
    }

    updateLookupFilter=(selectedfield:string)=>{
        return selectedfield
    }

    render() {
        return (<div className="slds-form-element">
            <label role="apiNameLayout" className="slds-form-element__label" htmlFor="text-input-id-1">
                <abbr className="slds-required" title="required">* </abbr>
                Object API Name
            </label>
            <div className="slds-form-element__control">
                <div className="slds-select_container">
                    <select 
                        name="apiName" 
                        id="text-input-id-2" 
                        role="apiName"  
                        className="slds-select" 
                        required 
                        onChange={this.onChange}
                        value={this.props.apiName}
                    >
                        <option value="">{'Please select'}</option>
                        {TemplateSFObjectStore.sfObjects && TemplateSFObjectStore.sfObjects.map((sfObject) => {
                            return (
                                <option key={sfObject.name} value={sfObject.name===''?this.state.apiName:sfObject.name}>{sfObject.label}</option>
                            );
                        })}
                    </select>
                </div>
                {
                    this.state.loadTriggeringField
                        ?
                        <div className="slds-m-vertical_small">
                            <ApplyTriggeringField
                                selectedTemplateName={this.props.selectedTemplateName}
                                changeHandler={this.onChange}
                                updateLookupFilter={this.updateLookupFilter}
                                selectedLookupFilter={this.state.objLayoutFieldsArray}
                                deleteLookupFilter={this.deleteLookupFilter}
                                addLayoutField={this.addLayoutField}
                            />
                        </div>
                        :
                        <div className="slds-m-vertical_small">
                            <button
                                className="slds-button slds-button_brand"
                                onClick={this.loadTriggeringFieldHandler}
                            >
                                {CQAppConstant.ADD_TRIGERRING_FIELDS}
                            </button>
                        </div>
                }
            </div>
        </div>);
    }

}
export default ReferenceUIType;